import api from './axios';
// =============================================================================
// ADMIN: CHARGE TEMPLATES
// =============================================================================
export const chargeTemplateApi = {
    getAll() {
        return api.get('/admin/charges/templates');
    },
    create(dto) {
        return api.post('/admin/charges/templates', dto);
    },
    update(id, dto) {
        return api.patch(`/admin/charges/templates/${id}`, dto);
    },
    delete(id) {
        return api.delete(`/admin/charges/templates/${id}`);
    },
};
export default chargeTemplateApi;
// =============================================================================
// PROVIDER: SERVICE CHARGES
// =============================================================================
export const serviceChargeApi = {
    attachTemplates(serviceId, chargeTemplateIds) {
        return api.post(`/services/${serviceId}/charges/templates`, { chargeTemplateIds });
    },
    detachTemplate(serviceId, templateId) {
        return api.delete(`/services/${serviceId}/charges/templates/${templateId}`);
    },
    createCustom(serviceId, dto) {
        return api.post(`/services/${serviceId}/charges/custom`, dto);
    },
    updateCustom(serviceId, chargeId, dto) {
        return api.patch(`/services/${serviceId}/charges/custom/${chargeId}`, dto);
    },
    deleteCustom(serviceId, chargeId) {
        return api.delete(`/services/${serviceId}/charges/custom/${chargeId}`);
    },
};
